import { createDataHandler } from "./metadata.js";
//#region src/handler/longpress.ts
/**
* Navigation handler factory that creates a handler that enables long presd action variants for a node.
*
* @see {@link LongPressOptions} for options.
*/
const longPressHandler = createDataHandler("longPress", { enabled: true });
//#endregion
export { longPressHandler };

//# sourceMappingURL=longpress.js.map